export default "__VITE_ASSET__BKUcewdt__"